var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "__btn_input_active",
      on: {
        click: function($event) {
          return _vm.clickAccount(_vm.account)
        }
      }
    },
    [
      _c("div", { staticClass: "name __ellipsis" }, [
        _vm._v(_vm._s(_vm.account.name))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "address __ellipsis" }, [
        _vm._v(_vm._s(_vm.account.showAddr))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }